import React, {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import dateFormat from "dateformat";

import { Calendar, Header, Title } from "@/components";
import { moscowNow } from "@/utils/date/moscowNow";

import styles from "./CourtRentCalendar.module.scss";

import { setRentDateToStorage } from "@/utils";
import { CourtRentCalendarPropsType } from "./types";

export const CourtRentCalendar: React.FC<CourtRentCalendarPropsType> = ({ title }) => {
  const navigate = useNavigate();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleSelectDate = (calendarDate: Date) => {
    const date = dateFormat(calendarDate, "isoDate");
    setRentDateToStorage(date);
    navigate("/choosing-room");
  };

  const handleChooseCourtToday = () => {
    const today = dateFormat(moscowNow(), "isoDate");
    setRentDateToStorage(today);
    navigate("/choosing-room");
  };

  const handleChooseCourtTodayKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleChooseCourtToday();
    }
  };

  return (
    <>
      <Header title={title} />
      <main>
        <section className={`container ${styles.section}`}>
          <Title>
            {title}
          </Title>
          <p className={styles.description}>
            Выберите день для аренды
          </p>
          <Calendar onSelectDate={handleSelectDate} />
          <button
            type="button"
            className={styles.chooseCourtButton}
            onClick={handleChooseCourtToday}
            onKeyDown={handleChooseCourtTodayKeyDown}
            tabIndex={0}
            aria-label="Выбрать корт на сегодня"
          >
            Выбрать корт
          </button>
        </section>
      </main>
    </>
  );
};
